<template>
  <div class="loginbg">
    <div class="contentfrom">
      <img :src="headLogo" width="130"/>
      <H1 class="loginTitle">{{ systemName }}</H1>
      <el-card class="box-card">
        <el-form ref="login" :model="form" label-width="0" :rules="ruleLogin">
          <el-form-item style="margin-top:40px;" prop="loginPhone">
            <el-input placeholder="请输入手机号码" v-model.trim="form.loginPhone">
              <img src="../images/account.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:40px;" prop="verifyCode">
            <el-input :placeholder="showButtonSend ? '请输入验证码' : '请输入手机后六位'" v-model.trim="form.verifyCode" type="text" maxlength="6">
              <img src="../images/password.png" slot="prepend" width="20"/>
              <el-button v-if="showButtonSend" slot="append" round class="appendbtn" size="mini" @click="getcode" :disabled="!canClick">
                {{ getCodeTitle }}
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="login" type="primary" style="width: 100%; margin: 20px 0" round class="mt20">登录</el-button>
        <p v-if="!showButtonSend">注：请输入手机号后六位登录，未注册用户请点击下方客服按钮。</p>
        <p style="text-align: right; font-size: 10px; color: #409EFF" id="yingyuchat" @click="contactCustomerService">联系客服</p>
      </el-card>
      <el-button v-if="isXbmuBtn" @click="aiInterview" type="primary" style="width: 100%; margin: 20px 0; background: #826AF9;border: none" round class="mt20">AI模拟面试系统<i class="el-icon-right"></i></el-button>
    </div>
    
    <div class="foot">
      <p>Copyright © www.rennengda.com All Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
import HttpRequest from "@/utils/request";
import {setSessionData, savePersistentStudent, savePersistentPartner, savePersistentLoginPage, loadPersistentStudent, loadPersistentPartner, loadPersistentLoginPage, loadAdmin} from "../utils/cache";
import {getFrameMenus} from "@/assets/js/consult";
import setWechatTitle from "@/utils/setWechatTitle.js";
import { getConsultModule } from "../assets/js/application.js"

export default {
  name: "leftMenu",
  data() {
    var validatePhone = (rule, value, callback) => {
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!myreg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    };
    return {
      ruleLogin: {
        verifyCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        loginPhone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'},
        ],
      },
      form: {
        partner: null,
        loginPhone: "",
        verifyCode: "",
      },
      canClick: true,
      totalTime: 60,
      getCodeTitle: '获取验证码',
      headLogo: '',
      openOtherHomepage: '0',
      isXbmuBtn: false,
      target: null,
      systemName: "生涯咨询预约中心",
      // showButtonSend: false,
      targetTime: new Date("2025-04-17T00:00:00").getTime(),
    };
  },
  computed: {
    showButtonSend() {
      return Date.now() >= this.targetTime; // 当前时间 >= 目标时间时才显示
    },
  },
  created() {
    // 如果 URL 中有 ticket 参数，跳转到 casLogin 处理 CAS 单点登录
    let ticket = this.$route.query.ticket
    if (ticket) {
      this.$router.replace({path: '/casLogin', query: this.$route.query})
      return
    }
    // 如果是 24sxu 学校，直接跳转到 casLogin 页面
    let partner = this.$route.query.partner
    if (partner === '24sxu') {
      this.$router.replace({path: '/casLogin', query: this.$route.query})
      return
    }
    // 检查是否有持久化的登录凭据，有则直接跳转
    let persistentStudent = loadPersistentStudent()
    let persistentPartner = loadPersistentPartner()
    if (persistentStudent && persistentStudent.token && persistentPartner) {
      let loginPage = loadPersistentLoginPage()
      setSessionData("partner", persistentPartner)
      setSessionData("loginPage", loginPage)
      store.dispatch('setStudent', persistentStudent)
      store.dispatch('setLoginStatus', 1)
      // 从 URL 读取 target 参数，保持和正常登录流程一致
      this.target = this.$route.query.target
      this.openOtherHomepage = this.$route.query.openOtherHomepage
      this.getAdmin(persistentPartner, persistentStudent.token, persistentStudent.studentName)
      return
    }
    console.log("当前时间：", new Date(Date.now()).toLocaleString());
    console.log("目标时间：", new Date(this.targetTime).toLocaleString());
    console.log(this.showButtonSend,'----')
    if (!partner || partner === 'undefined') {
      this.$alert('登录网址不对');
    } else {
      this.form.partner = partner
      if(partner == "xbmu") {
        this.isXbmuBtn = true
        this.systemName = "AI面试亭预约"
        setWechatTitle("AI面试亭预约");
      }
      this.headLogo = 'https://sys.rennengda.com/consult/logos/head-' + partner + '.png';
      this.openOtherHomepage = this.$route.query.openOtherHomepage
      this.target = this.$route.query.target
    }
  },
  mounted() {
  },
  methods: {
    contactCustomerService() {
      console.log('11111')
      let partner = this.$route.query.partner
      this.$router.push("/customerService" + '?partner=' + partner)
    },
    isMobile() {
       return /Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Mobile/i.test(navigator.userAgent);
    },

    aiInterview() {
    //  if(this.isMobile()) {
    //   window.location.href = 'weixin://dl/business/?appid=wx5f666cd6b33877ae&path=pages/home/index&env_version=release';
    //  } else {
      window.location.href = 'https://growup.aminer.cn/student/login';
    //  }
    },
    getAdmin(partner, token, name) {
      if (this.target) {
        let url = "/constub/gainAdminMenu";
        HttpRequest.requestFormPost(url, {partner, token}).then((res) => {
          store.dispatch('setAdmin', res.data)
          this.$router.push('/' + this.target + '?partner=' + partner)
        })
        return
      }
      let url = "/constub/gainAdminMenu";
      HttpRequest.requestFormPost(url, {partner: partner, token: token}).then((res) => {
        let admin = res.data
        if (this.openOtherHomepage !== '1' || admin.jsonSetting.save_other_homepage !== 1) {
          admin.jsonSetting.open_homepage = ""
        }
        store.dispatch('setAdmin', admin)
        // let consult_SmartPavilion = admin.jsonSetting.consult_SmartPavilion
        // let menus = getFrameMenus(consult_SmartPavilion, admin.jsonSetting.open_homepage)
        // let menus = getConsultModule(consult_SmartPavilion)
        // let r = menus[0].path
        if (name){
          // this.$router.push('/' + r + '?partner=' + partner);
          if(admin.jsonSetting.consult_SmartPavilion == 1) {
             //判断是否只有面试亭
            this.$router.push('/pavilionAppoint?' + 'partner=' + partner)
          } else {
            if(this.openOtherHomepage == 1 && admin.jsonSetting.open_homepage == 'questCenter') {
              this.$router.push('/questCenter?' + 'partner=' + partner)
            } else {
              this.$router.push('/home' + '?partner=' + partner);
            }
          }
        } else {
          this.$alert('首次登录，请先填写个人资料', {
            showClose: false,
            confirmButtonText: '继续',
            callback: action => {
              // this.$router.push('/firstPersonalData?pathfrom=' + r);
              if(admin.jsonSetting.consult_SmartPavilion == 1) {
                this.$router.push('/firstPersonalData?pathfrom=' + 'pavilionAppoint')
              } else if(this.openOtherHomepage == 1 && admin.jsonSetting.open_homepage == 'questCenter'){
                this.$router.push('/firstPersonalData?pathfrom=' + 'questCenter')
              } else{
                this.$router.push('/firstPersonalData?pathfrom=' + 'home')
              }
            }
          });
        }
      });
    },
    login() {
      this.$refs["login"].validate((valid) => {
        let partner = this.form.partner
        if (valid) {
          let url = "/constub/loginBySms";
          let data = {partner: partner, loginPhone: this.form.loginPhone, verifyCode: this.form.verifyCode};
          HttpRequest.requestFormPost(url, data).then((res) => {
            if (res && res.result.success) {
              setSessionData("partner", partner)
              setSessionData("logoutUrl", null);
              setSessionData("loginPage", "login");
              store.dispatch('setStudent', res.data)
              store.dispatch('setLoginStatus', 1)
              // 持久化登录凭据到 localStorage
              savePersistentStudent(res.data)
              savePersistentPartner(partner)
              savePersistentLoginPage("login")
              this.getAdmin(partner, res.data.token, res.data.studentName)
            } else {
              this.$alert(res.result.message, {
                confirmButtonText: '确定',
                showClose: false,
              });
            }
          });
        }
      })
    },
    getcode() {
      if (!this.form.partner) {
        this.$message.error('登录网址不对');
        return;
      }
      let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!phoneReg.test(this.form.loginPhone)) {
        this.$message({message: '手机号码不正确', type: "warning",});
        return;
      }
      if (this.canClick) {
        this.canClick = false;
        //倒计时
        this.getCodeTitle = this.totalTime + 's后重新发送'
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.getCodeTitle = this.totalTime + 's后重新发送';
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.getCodeTitle = '重新发送验证码'
            this.totalTime = 60;
            this.canClick = true;
          }
        }, 1000);
        //发送验证码
        let url = "/constub/sendVerifyCode";
        let data = {partner: this.form.partner, toPhoneNum: this.form.loginPhone};
        HttpRequest.requestFormPost(url, data).then((res) => {
          if (res && res.result.success) {
            this.$message({message: res.data, type: "success",});
          } else {
            this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.loginbg {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url('../images/bg.png');
  background-size: cover
}

.contentfrom {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  text-align: center;
}

.contentfrom input {
  border: 0;
}

>>> .el-input-group__append,
>>> .el-input-group__prepend {
  border: 0;
  border-radius: 0;
  background: none;
  border-bottom: 1px solid #8d93b9;
}

>>> .el-input__inner {
  color: #8d93b9;
  background: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #8d93b9;
}

.appendbtn {
  border: 1px solid #8d93b9 !important;
}

.loginTitle {
  margin: 20px 0 40px;
  color: #fff;
}

.foot {
  position: absolute;
  width: 80%;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
}
</style>
